/* import __COLOCATED_TEMPLATE__ from './reset-password-countdown.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';

class ResetPasswordCountdownComponent extends Component {
  @tracked count;

  constructor() {
    super(...arguments);
    this.countdown.perform(this.args.count);
  }

  @task *countdown(count) {
    this.count = count;

    while (this.count > 0) {
      yield timeout(1000);
      this.count--;
    }

    this.args.onComplete();
  }
}

export default ResetPasswordCountdownComponent;
